import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  ThemeProvider,
  lightTheme,
  Typography,
} from "@common-ui/ui";
import AppsSharpIcon from "@mui/icons-material/AppsSharp";

import { getApplications } from "../../services";

const AppSwitcher = (props) => {
  // console.log("this.props", props)
  const APP_ICON =
    "https://m.media-amazon.com/images/S/abs-image-upload-na/4/AmazonStores/ATVPDKIKX0DER/e2480482664e419074c29b7ff144941d.w400.h400.jpg";
  const APP_ICON_BASELINE =
    "https://d3ab4pgc1q9ec1.cloudfront.net/client/B_tab_logo.png";
  // const APP_ICON_MY_WORK =
  //   "https://d3ab4pgc1q9ec1.cloudfront.net/client/myWork.png";
  const APP_ICON_MY_WORK =
    "https://m.media-amazon.com/images/S/abs-image-upload-na/4/AmazonStores/ATVPDKIKX0DER/e2480482664e419074c29b7ff144941d.w400.h400.jpg";
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [myApplications, setMyApplications] = useState([]);
  const [halfwayLimit, setHalfwayLimit] = useState([]);
  const [columnA, setColumnA] = useState([]);
  const [columnB, setColumnB] = useState([]);
  let uniq, res;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function init() {
    try {
      let { apps } = await getApplications();
      uniq = new Set(apps.map((e) => JSON.stringify(e)));
      res = Array.from(uniq).map((e) => JSON.parse(e));
      res = [
        ...res,
        {
          name: "My Work",
          url: "https://mywork.fluke.com/",
          send_token: false,
        },
      ];
      // console.log("res", res);
      setMyApplications(res);
    } catch (error) {
      console.log(error);
    }
  }

  // Splits the apps array into two for dynamic usage of 2-column grid.
  useEffect(() => {
    const limitValue = Math.ceil(myApplications.length / 2);
    setHalfwayLimit(limitValue);
    setColumnA(myApplications.slice(0, halfwayLimit));
    setColumnB(myApplications.slice(halfwayLimit));
  }, [myApplications, halfwayLimit]);

  return (
    <>
      <Box>
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ mr: 1 }}
          aria-controls={open ? "apps-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <AppsSharpIcon fontSize="large" aria-haspopup="true" />
        </IconButton>
      </Box>
      <ThemeProvider theme={lightTheme}>
        <Menu
          anchorEl={anchorEl}
          id="apps-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          disableAutoFocusItem
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              p: 2,
              // bgcolor: "#333333",
              // "& .MuiAvatar-root": {
              //   width: 32,
              //   height: 32,
              //   ml: -0.5,
              //   mr: 1,
              // },
              // "&:before": {
              //   content: '""',
              //   display: "block",
              //   position: "absolute",
              //   top: 0,
              //   right: 14,
              //   width: 10,
              //   height: 10,
              //   bgcolor: "#333333",
              //   transform: "translateY(-50%) rotate(45deg)",
              //   zIndex: 0,
              // },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <Grid container mb={20}>
            <Grid item xs={6}>
              {columnA.length
                ? columnA.map((data) => (
                    <MenuItem key={Math.random().toString(16).slice(2)}>
                      <Link
                        href={data.url}
                        underline="none"
                        rel="noopener"
                        target="_blank"
                        color="white"
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            flexDirection: "column",
                          }}
                        >
                          <img
                            src={
                              String(data?.name).toLowerCase() === "baseline"
                                ? APP_ICON_BASELINE
                                : String(data?.name).toLowerCase() === "my work"
                                ? APP_ICON_MY_WORK
                                : APP_ICON
                            }
                            alt="app"
                            width={70}
                            height={70}
                          />
                          <Typography
                            variant="body1"
                            // fontWeight="700"
                            color="text.primary"
                          >
                            {data.name}
                          </Typography>
                        </div>
                      </Link>
                    </MenuItem>
                  ))
                : ""}
            </Grid>
            <Grid item xs={6}>
              {columnB.length
                ? columnB.map((dataB) => (
                    <MenuItem key={Math.random().toString(16).slice(3)}>
                      <Link
                        href={dataB.url}
                        underline="none"
                        rel="noopener"
                        target="_blank"
                        color="white"
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            flexDirection: "column",
                          }}
                        >
                          <img
                            src={
                              String(dataB?.name).toLowerCase() === "baseline"
                                ? APP_ICON_BASELINE
                                : String(dataB?.name).toLowerCase() ===
                                  "my work"
                                ? APP_ICON_MY_WORK
                                : APP_ICON
                            }
                            alt="app"
                            width={70}
                            height={70}
                          />
                          <Typography
                            variant="body1"
                            // fontWeight="700"
                            color="text.primary"
                          >
                            {dataB.name}
                          </Typography>
                        </div>
                      </Link>
                    </MenuItem>
                  ))
                : ""}
            </Grid>
          </Grid>
          <div style={{ mt: 10, mb: 10 }}>
            <Button
              color="secondary"
              fullWidth
              size="small"
              type="button"
              variant="contained"
              onClick={() => {
                window.open("https://software.fluke.com/", "_blank");
              }}
            >
              See More from Fluke
            </Button>
          </div>
        </Menu>
      </ThemeProvider>
    </>
  );
};

export default AppSwitcher;
